module.exports = __webpack_public_path__ + "img/product5.4f55cbd7.png";